import React from 'react';
import ReactDOM from 'react-dom';
import { withStyles } from 'material-ui/styles';
import SearchPieceGeneric from './pieces/search_piece_generic';
import SearchResultGeneric from './results/search_result_generic.js';
import ErrorBoundary from './ui/error_boundary.js';
import AdminResult from './admin/result.js';
import Handlers from './admin/handlers.js';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';

const styles = theme => ({
  block: {
    display : 'block',
  },
  piece:{
    marginTop: 10,
  },
  result: {
    margin: 0,
    marginTop: 25,
    padding: 0,
  },
  card: {
    width: '100%',
    boxSizing: 'border-box',
    padding: 5,    
    marginBottom: 10,
    overflowX: 'hidden',
  },
  devMode : {
    backgroundColor: '#C0C0C0',
    padding: 10,
    border: '1px dashed black',
    marginTop: 35,
  },
  errorTitle :{
    fontSize: 12,
    fontWeight: 'bold',
  },
  error: {
    fontSize: 12,
    color: 'red',
  },
  author: {
    fontSize: 6,
    color: '#808080',
    position: 'absolute',
    bottom: '0',
    right: '0',
    padding: 2,
    margin: 3,
    backgroundColor: 'RGBA(255,255,255,0.8)',    
  },
});

class SearchResultsItemDiv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.hMgr = new Handlers();
  }
  
  prepareMetatags(item){
    if(this.props.devMode && item.pagemap.metatags){
    }

    if(item.pagemap.metatags && item.pagemap.metatags[0]['og:type'] === 'profile' && item.displayLink === 'www.instagram.com'){
      item.pagemap.instagram = item.pagemap.metatags;
    }

    if(item.pagemap.metatags && item.displayLink.includes('wikipedia.org')){
      item.pagemap.wikipedia = item.pagemap.metatags;
    }

    item.type = '-';
    if(item.pagemap.metatags){
      if(item.pagemap.metatags[0]['og:site_name'] === 'IMDb'){
        item.type = 'imdb';
      }
    }
  }

  renderA(results, extras, pieces){
    const classes = this.props.classes;
    var key = 0;
    var padL = 0, padR = 3;
    return (
      <Grid item xs={12} className={classes.result}>
        <Grid container>
          <Grid item xs={12} sm={padR}>
            {pieces.length > 0 &&
              <Paper className={classes.card} key={key++}>
                {pieces.map(piece=>
                  <ErrorBoundary key={key++}>
                    {piece.jsx}
                  </ErrorBoundary>
                )}
              </Paper>
            }
          </Grid>
          <Grid item xs={12} sm={12 - padL - padR}>
            {results.map(result=>
              <ErrorBoundary key={key++}>
                {result.jsx}
              </ErrorBoundary>
            )}
            {extras.map(result=>
              <ErrorBoundary key={key++}>
                {result.jsx}
              </ErrorBoundary>
            )}
          </Grid>
        </Grid>
      </Grid>      
    );      
  }

  renderB(results, extras, pieces){
    const classes = this.props.classes;
    var key = 0;
    var padL = 0, padR = 3;
    return (
      <Grid item xs={12} className={classes.result}>
        <Grid container>
          <Grid item xs={12} sm={12 - padL - padR}>
            {results.map(result=>
              <ErrorBoundary key={key++}>
                {result.jsx}
              </ErrorBoundary>
            )}
            {extras.map(result=>
              <ErrorBoundary key={key++}>
                {result.jsx}
              </ErrorBoundary>
            )}
          </Grid>
          <Grid item xs={12} sm={padR}>
            {pieces.length > 0 &&
              <Paper className={classes.card} key={key++}>
                {pieces.map(piece=>
                  <ErrorBoundary key={key++}>
                    {piece.jsx}
                  </ErrorBoundary>
                )}
              </Paper>              
            }
          </Grid>
        </Grid>
      </Grid>
    );
  }


  render() {
    var key = 0;
    const rendered = [];
    const results = [];
    const extras = [];
    const pieces = [];
    const classes = this.props.classes;
    const sections = (this.props.item.pagemap) ? Object.keys(this.props.item.pagemap) : [];
    const hdlrs = this.hMgr.getHandlers(this.props.item);

    if(this.props.item.pagemap){
      this.prepareMetatags(this.props.item);  
      var result, data, type;
      if(hdlrs.length > 0){
        for(var i = 0; i < hdlrs.length; i++){
          if(rendered.indexOf(hdlrs[i].renderer.name) >= 0) continue;
          try{
            type = hdlrs[i].type;
            data = hdlrs[i].extractor.extractor.extract(this.props.item);
            if(('has_data' in data) && data['has_data'] === 0){
              continue;
            } 
            result =  hdlrs[i].renderer.render(data,  {key: ++key});
          }catch (ex){
            console.log("Error", hdlrs[i].extractor.name, hdlrs[i].renderer.name, ex);
            result = <div className={classes.error}>
                        <div className={classes.errorTitle}>{hdlrs[i].extractor.name} => {hdlrs[i].renderer.name}</div>
                        <div>{ex.toString()}</div>
                      </div>;
          }

          var hook = hdlrs[i].name;
          
          if(type === 'result'){
            results.push({jsx: result, hook: hook, renderer: hdlrs[i].renderer})
          } else if(type === 'result-extra'){
            extras.push({jsx: result, hook: hook, renderer: hdlrs[i].renderer})
          } else {
            pieces.push({jsx: result, hook: hook, renderer: hdlrs[i].renderer})
          }
          rendered.push(hdlrs[i].renderer.name);
        }      
      }      
    }

   if(results.length === 0){
      result = <SearchResultGeneric key={key++} item={this.props.item} type={'generic'} server={this.props.server}/>;
      results.push({jsx: result, hook: 'generic', renderer: {meta : 'generic', name : 'Generic Result'}})
    }

    if(this.props.devMode){
      for(var sec in sections){
        result = <SearchPieceGeneric item={this.props.item} section={sections[sec]}/>;
        pieces.push({jsx: result, hook: sections[sec], renderer: {meta: sections[sec], name: 'Generic Piece'}})   
      }
    }

    for(var i in pieces){
      pieces[i].jsx = <div className={classes.piece}>{pieces[i].jsx}</div>;
    }

    var row, devRow, padL = 0, padR = 3;
    row = (!this.props.uiOptions.piecePlace) ? this.renderA(results, extras, pieces) : this.renderB(results, extras, pieces);  

    devRow = (this.props.devMode) ?
      <Grid item xs={12} className={classes.devMode}>
        <AdminResult item={this.props.item} server={this.props.server} handlers={hdlrs} pieces={pieces} results={results}/>
      </Grid>
      :
      <span/>
      ;   

    return (
      <div>
        <Grid container>
          {devRow}
          {row}
        </Grid>
      </div>
    );    
  }
}

export default withStyles(styles)(SearchResultsItemDiv);


// WEBPACK FOOTER //
// ./src/search/search_results_item_div.js